import React from 'react';
import { Github, Twitter, Mail } from 'lucide-react';
export function Footer() {
  return <footer className="bg-gray-900 text-gray-300 py-12" data-id="element-171">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-172">
        <div className="grid md:grid-cols-4 gap-8 mb-8" data-id="element-173">
          <div className="md:col-span-2" data-id="element-174">
            <h3 className="text-white text-xl font-bold mb-4" data-id="element-175">Cefapay Card</h3>
            <p className="text-gray-400 leading-relaxed max-w-md" data-id="element-176">
              La solution de paiement sans frontières pour l'Afrique de l'Ouest.
              Rechargez par Wave, dépensez partout dans le monde.
            </p>
          </div>

          <div data-id="element-177">
            <h4 className="text-white font-semibold mb-4" data-id="element-178">Légal</h4>
            <ul className="space-y-2" data-id="element-179">
              <li data-id="element-180">
                <a href="/terms" onClick={e => {
                e.preventDefault();
                window.location.href = '/terms';
              }} className="hover:text-white transition-colors" data-id="element-181">
                  Conditions d'utilisation
                </a>
              </li>
              <li data-id="element-182">
                <a href="#" className="hover:text-white transition-colors" data-id="element-183">
                  Politique de confidentialité
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-184">
            <h4 className="text-white font-semibold mb-4" data-id="element-185">Connexion</h4>
            <div className="flex gap-4" data-id="element-186">
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-gray-700 transition-colors" data-id="element-187">
                <Twitter className="w-5 h-5" data-id="element-188" />
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-gray-700 transition-colors" data-id="element-189">
                <Github className="w-5 h-5" data-id="element-190" />
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-gray-700 transition-colors" data-id="element-191">
                <Mail className="w-5 h-5" data-id="element-192" />
              </a>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-gray-800 text-center text-gray-400 text-sm" data-id="element-193">
          <p data-id="element-194">
            © {new Date().getFullYear()} Cefapay Card. Tous droits réservés.
          </p>
          <p className="mt-2" data-id="element-195">
            Service indépendant facilitant l'accès aux paiements internationaux.
          </p>
        </div>
      </div>
    </footer>;
}